
import styles from "./HeaderLogo.module.scss"
import logo from '../../../../shared/assets/photo/logo.png'
import { Link } from "react-router-dom";



export const HeaderLogo = () => {
    return (
        <Link to = '/'>
            <img className={styles.logo} src={logo} alt="logo"/>
        </Link>
    )
}